module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "moduleName": "H5-global-fe-cs-ticket-system",
  "filePath": "/src/locales",
  "prefix": "kfcommon-fe-i18n---",
  "noParse": true,
  "version": 0,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-global-fe-cs-ticket-system/src/locales/all.js"
}